export default "__VITE_ASSET__BbJQfSN4__"